import { createContext, FunctionComponent, ReactNode, useContext, useEffect, useState } from 'react';
import * as auth_api from '../api/auth';

export enum AuthStatus {
	LOADING = 1,
	NOT_LOGGED,
	LOGGED_IN
 }

export const AuthContext = createContext<{ status: AuthStatus, data: any, login: any, logout: any }>({ status: AuthStatus.LOADING, data: null, login: null, logout: null });

const AuthProvider: FunctionComponent<{ children: ReactNode }> = ({ children }: { children: ReactNode }) => {
	const login = async (username, otp) => {
		try {
			await auth_api.login({username, password: otp});
			checkAuth();
			return true
		} catch (err) {
			return false
		}
	}

	const logout = async () => {
		try {
			await auth_api.logout();
			checkAuth();
		} catch (err) {
			return 'Error ocurred trying to logout'
		}
	}


	const [data, setData] = useState<{ status: AuthStatus, data: any, login: any, logout: any }>({ status: AuthStatus.LOADING, data: null, login: login, logout: logout});


	const checkAuth = async () => {
		try {
			const resp = await auth_api.check();

			if (resp.data && resp.data.isLogged == true) {
				setData({status: AuthStatus.LOGGED_IN, data: resp.data.data, login: login, logout: logout})
			} else {
				setData({status: AuthStatus.NOT_LOGGED, data: null, login: login, logout: logout})
			}
		} catch (error) {
			setData({status: AuthStatus.NOT_LOGGED, data: null, login: login, logout: logout})
		}
	}

	useEffect(() => {
		checkAuth();
	}, []);

	return <AuthContext.Provider value={data}>{children}</AuthContext.Provider>;
};

export const useAuth = (): { status: AuthStatus, data: any, login: any, logout: any } | null => {
	const ctx = useContext(AuthContext);
	if (ctx === undefined) {
		throw new Error('useAuth can only be used inside AuthProvider');
	}
	return ctx;
};

export default AuthProvider;